'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
import * as $j_mealorama$002e$002dStore$002dCart$002dItem$002dState from "./mealorama.-Store-Cart-Item-State.js";
var $p;
/** @constructor */
function $c_Lmealorama_StoreCartItemState$$anon$2(\u03b4name$4, _$ordinal$4) {
  this.ZE = null;
  this.ZE = \u03b4name$4;
}
export { $c_Lmealorama_StoreCartItemState$$anon$2 as $c_Lmealorama_StoreCartItemState$$anon$2 };
$p = $c_Lmealorama_StoreCartItemState$$anon$2.prototype = new $j_mealorama$002e$002dStore$002dCart$002dItem$002dState.$h_Lmealorama_StoreCartItemState();
$p.constructor = $c_Lmealorama_StoreCartItemState$$anon$2;
/** @constructor */
function $h_Lmealorama_StoreCartItemState$$anon$2() {
}
export { $h_Lmealorama_StoreCartItemState$$anon$2 as $h_Lmealorama_StoreCartItemState$$anon$2 };
$h_Lmealorama_StoreCartItemState$$anon$2.prototype = $p;
$p.q = (function() {
  return 0;
});
$p.g = (function(n) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sr_EnumValue__productElement__I__O(this, n);
});
$p.r = (function() {
  return this.ZE;
});
$p.m = (function() {
  return this.ZE;
});
$p.p = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_T__hashCode__I(this.ZE);
});
var $d_Lmealorama_StoreCartItemState$$anon$2 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lmealorama_StoreCartItemState$$anon$2, "mealorama.StoreCartItemState$$anon$2", ({
  H6: 1,
  k1: 1,
  b: 1,
  c: 1,
  a: 1,
  l: 1,
  n: 1,
  d: 1,
  e: 1,
  h: 1
}));
export { $d_Lmealorama_StoreCartItemState$$anon$2 as $d_Lmealorama_StoreCartItemState$$anon$2 };
//# sourceMappingURL=mealorama.-Store-Cart-Item-State$$anon$2.js.map
